import queryString from 'query-string';

import { AdditionalFiltersType } from '../reporting/applicant-export';

import * as Api from './api';
import { JobRoutes } from './routes/api-job-routes';

// TODO - Separate out base url
class Job {
  jobId: number;

  constructor(jobId: number) {
    this.jobId = jobId;
  }

  route = (uri: string) => JobRoutes.getJobRoute(this.jobId, uri);

  get = () => Api.get(this.route(JobRoutes.JOB));

  delete = () => Api.del(this.route(JobRoutes.JOB));

  update = (jobUpdate: Record<string, any>) =>
    Api.post(this.route(JobRoutes.JOB), {
      body: JSON.stringify(jobUpdate),
    });

  updateMonthlyCreditDollars = (monthlyCreditDollars: number) =>
    Api.post(this.route(JobRoutes.MONTHLY_CREDIT_DOLLARS), {
      body: JSON.stringify({ monthlyCreditDollars }),
    });

  updateIsDeterminingFacebookCPA = (isDeterminingFacebookCPA: boolean) =>
    Api.post(this.route('/is-determining-facebook-cpa'), {
      body: JSON.stringify({ isDeterminingFacebookCPA }),
    });

  updateStatus = (status: JobStatus) =>
    Api.post(this.route(JobRoutes.ACTIVE), {
      body: JSON.stringify({ status }),
    });

  getApplicationLabels = () => Api.get(this.route(JobRoutes.APPLICATIONS_LABELS));

  getApplicantExport = (
    startDate: string,
    endDate: string,
    tz: string,
    filter?: string,
    chartType?: string,
    includeAutoScreened?: 0 | 1,
    additionalFilters: AdditionalFiltersType = {},
  ) =>
    Api.get(
      this.route(
        `$/applications/export?${queryString.stringify({
          startDate,
          endDate,
          tz,
          filter,
          chartType,
          includeAutoScreened,
          ...additionalFilters,
        })}`,
      ),
    );

  getEeoExport = (
    startDate: string,
    endDate: string,
    tz: string,
    filter?: string,
    chartType?: string,
    includeAutoScreened?: 0 | 1,
    additionalFilters: AdditionalFiltersType = {},
  ) =>
    Api.get(
      this.route(
        `$/applications/eeo-export?${queryString.stringify({
          startDate,
          endDate,
          tz,
          filter,
          chartType,
          includeAutoScreened,
          ...additionalFilters,
        })}`,
      ),
    );

  getFacebookCampaign = () => Api.get(this.route(JobRoutes.FACEBOOK_CAMPAIGN));

  getTextMessageTemplates = (status?: string | null) =>
    Api.get(`${this.route(JobRoutes.TEXT_MESSAGE_TEMPLATES)}${status ? `?status=${status}` : ''}`);

  addTextMessageTemplate = (template: Record<string, any>) =>
    Api.post(this.route(JobRoutes.ADD_TEXT_MESSAGE_TEMPLATE), {
      body: JSON.stringify(template),
    });

  updateTextMessageTemplate = (templateUpdate: Record<string, any>) =>
    Api.post(this.route(JobRoutes.TEXT_MESSAGE_TEMPLATES), {
      body: JSON.stringify(templateUpdate),
    });

  populateNotificationSettingsFromOrg = (useDefaultJobNotificationSettings: boolean) =>
    Api.post(this.route(JobRoutes.NOTIFICATION_SUBSCRIPTIONS), {
      body: JSON.stringify({
        useDefaultJobNotificationSettings,
      }),
    });

  loadJobUsers = () => Api.get(this.route(JobRoutes.USERS));

  loadLabels = () => Api.get(this.route(JobRoutes.LABELS));

  loadReferrals = () => Api.get(this.route(JobRoutes.REFERRALS));

  loadJobDetails = () => Api.get(this.route(JobRoutes.DETAILS));

  createDemoApplicant = (phoneNumber: string | null) =>
    Api.post(this.route(JobRoutes.CREATE_DEMO_APPLICANT), {
      body: JSON.stringify({
        phoneNumber,
      }),
    });

  manuallyAddApplicant = (applicant: NewManualApplicant) =>
    Api.post(this.route(JobRoutes.APPLICANT), {
      body: JSON.stringify({
        applicant,
      }),
    });

  static loadNotificationTypes = () => Api.get(JobRoutes.GET_NOTIFICATION_TYPES);

  static all() {
    return Api.get(JobRoutes.GET_ALL_JOBS);
  }

  static getCommonFinalizingHireSteps = () => Api.get(JobRoutes.FINALIZING_HIRE_STEPS);
}

export default Job;
